"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSurveyHandles = exports.getSessionId = exports.addSession = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getSurveyHandles = exports.getSurveyHandles = function getSurveyHandles(collectionData) {
  var disabledSurveys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var handles = [];
  var flatCollection = Object.values(collectionData).flat();
  flatCollection.forEach(function (item) {
    var _metadata$surveyInfo;
    if (item.disabled || disabledSurveys.includes(item.id)) {
      return;
    }
    var metadata = JSON.parse(item.resource.published_metadata);
    var handle = (_metadata$surveyInfo = metadata.surveyInfo) === null || _metadata$surveyInfo === void 0 ? void 0 : _metadata$surveyInfo.surveyHandle;
    if (handle) {
      handles.push(handle);
    }
  });
  return handles;
};
var addSession = exports.addSession = function addSession(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'Timepoint' : _ref$name,
    _ref$sessionCollectio = _ref.sessionCollection,
    sessionCollection = _ref$sessionCollectio === void 0 ? [] : _ref$sessionCollectio,
    _ref$bucketName = _ref.bucketName,
    bucketName = _ref$bucketName === void 0 ? '' : _ref$bucketName,
    opensAt = _ref.opensAt,
    closesAt = _ref.closesAt,
    sessionId = _ref.sessionId,
    setSessions = _ref.setSessions,
    _ref$collectionBucket = _ref.collectionBuckets,
    collectionBuckets = _ref$collectionBucket === void 0 ? [] : _ref$collectionBucket,
    _ref$deployments = _ref.deployments,
    deployments = _ref$deployments === void 0 ? [] : _ref$deployments,
    getSessionId = _ref.getSessionId;
  var session = {};
  setSessions(function (prev) {
    var _deployments$find;
    var sessionsPerBucket = {};
    collectionBuckets.forEach(function (b) {
      sessionsPerBucket[b] = prev.filter(function (s) {
        return s.settings.reporter === b;
      });
    });
    session = {
      label: name || 'Timepoint',
      // May need to set deploymentId from app if it is not found in getDeployments query
      deploymentId: (_deployments$find = deployments.find(function (deployment) {
        return deployment.deploymentHandle === bucketName;
      })) === null || _deployments$find === void 0 ? void 0 : _deployments$find.deploymentId,
      sessionType: 'offset',
      offset: 0,
      opensAt: opensAt,
      closesAt: closesAt,
      settings: {
        options: getSurveyHandles(sessionCollection),
        toggleForRequired: true,
        reporter: bucketName,
        resourceIds: sessionCollection.map(function (r) {
          return r.id;
        }),
        disabledSurveys: [],
        sessionId: sessionId || getSessionId(sessionsPerBucket[bucketName], bucketName),
        sessionCollection: sessionCollection
      }
    };
    return [].concat(_toConsumableArray(prev), [session]);
  });
  return session;
};
var getSessionId = exports.getSessionId = function getSessionId(currentSessions, bucketName) {
  var proposedId = currentSessions.length;
  var sessionId = bucketName + proposedId;
  while (currentSessions.map(function (s) {
    return s.settings.sessionId;
  }).includes(sessionId)) {
    proposedId += 1;
    sessionId = bucketName + proposedId;
  }
  return sessionId;
};